module.exports = __webpack_public_path__ + "static/domestic_mental_obj04_m@2x-8ece47dc6923f172be61b2f1ecbe0891.jpg";